import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Globe, ShoppingCartSimple } from "@phosphor-icons/react";
import { api, money } from "../lib/api";
import { useCart } from "../context/CartContext";

export const RamonaBanner = () => {
  const { addItem } = useCart();
  const [beer, setBeer] = useState(null);

  useEffect(() => {
    api.get("/beers").then(({ data }) => setBeer(data.find((b) => b.name.toLowerCase().includes("ramona")) || null));
  }, []);

  const add = () => {
    addItem(beer, 1);
    toast.success(`${beer.name} agregada al carrito`);
  };

  return (
    <section className="relative overflow-hidden bg-[#140c08] border-y border-[#C9A24B]/30" data-testid="ramona-banner">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_75%_50%,rgba(201,162,75,0.16),transparent_60%)]" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-8 py-12 md:py-16 flex flex-col-reverse md:flex-row items-center gap-10 md:gap-16">
        <div className="flex-1 text-center md:text-left">
          <div className="inline-flex items-center gap-2 border border-[#C9A24B]/60 bg-[#C9A24B]/10 text-[#E8C979] px-3 py-1.5 text-[11px] uppercase tracking-[0.2em]" data-testid="ramona-exclusive-badge">
            <Globe size={14} weight="bold" /> Exclusiva web · Solo aquí
          </div>
          <h2 className="font-display text-6xl md:text-8xl leading-none text-[#F3E3BF] mt-5" data-testid="ramona-title">RAMONA</h2>
          <p className="font-display text-2xl md:text-3xl text-[#C9A24B] mt-2">Colección Privada · Farmhouse Negra</p>
          <p className="text-gray-400 text-sm md:text-base mt-5 max-w-xl mx-auto md:mx-0">
            Una cerveza Farmhouse negra de edición especial, de 5% vol. No la vas a encontrar en ninguna tienda: <span className="text-white">solo se vende a través de nuestra página web</span>. Pídela en línea y recíbela en casa.
          </p>
          {beer && (
            <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-4 mt-8">
              <div className="font-display text-4xl text-white" data-testid="ramona-price">{money(beer.price)}</div>
              <button
                onClick={add}
                className="inline-flex items-center gap-2 px-7 py-3 bg-[#C9A24B] hover:bg-[#E0B95C] text-black font-semibold uppercase tracking-wider text-sm transition-colors"
                data-testid="ramona-add-to-cart"
              >
                <ShoppingCartSimple size={18} weight="bold" /> Comprar en línea
              </button>
            </div>
          )}
        </div>
        <img
          src="/ramona-label.png"
          alt="GARAJE Ramona · Colección Privada · Cerveza Farmhouse Negra 5% Vol."
          className="w-[240px] md:w-[320px] h-auto drop-shadow-[0_25px_40px_rgba(0,0,0,0.7)] hover:-rotate-2 transition-transform duration-500"
          data-testid="ramona-label"
        />
      </div>
    </section>
  );
};
